if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this.classesToRemoveOnLoad = 'drawer--loading';
        this.drawerBody = this.querySelector(this.selector);
        this.quickviewAbortController = null;
      }

      abortPendingQuickview() {
        if (this.quickviewAbortController) {
          this.quickviewAbortController.abort();
          this.quickviewAbortController = null;
        }
      }

      get selector() {
        return '.quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      get controls() {
        if (this.id === 'QuickView-Shared') {
          return super.controls.filter((el) => this.contains(el));
        }
        return super.controls;
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        this.abortPendingQuickview();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.add(this.classesToRemoveOnLoad);
        this.removeAttribute('data-product-id');
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const productUrl = this.dataset.productUrl || '';
        const path = productUrl.startsWith('http')
          ? new URL(productUrl, window.location.origin).pathname
          : (productUrl.split('?')[0] || productUrl);
        if (!sectionId || !path) {
          console.warn('Quick view: missing section id or product URL', { sectionId: !!sectionId, path: !!path });
          return;
        }
        const sectionUrl = `${path}?section_id=${sectionId}`;

        this.abortPendingQuickview();
        const controller = new AbortController();
        this.quickviewAbortController = controller;

        fetch(sectionUrl, { credentials: 'same-origin', signal: controller.signal })
          .then((response) => response.text())
          .then((responseText) => {
            if (this.quickviewAbortController !== controller) return;

            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.selector);

            if (!productElement) {
              console.warn('Quick view: section response did not contain .quick-view__content');
              return;
            }
            this.setInnerHTML(drawerContent, productElement.innerHTML);
            FoxTheme.a11y.trapFocus(this, this.focusElement);
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: this.dataset.productUrl },
              })
            );
          })
          .catch((e) => {
            if (e && e.name === 'AbortError') return;
            console.error(e);
          })
          .finally(() => {
            if (this.quickviewAbortController === controller) {
              this.quickviewAbortController = null;
            }
          });
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = innerHTML;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        const productId = this.dataset.productId;
        if (productId) {
          element.querySelectorAll('[name="add"], .product-form__submit').forEach((button) => {
            button.setAttribute('data-product-id', productId);
          });
        }

        this.classList.remove(this.classesToRemoveOnLoad);
      }
    }
  );
}

(function initSharedQuickViewOpener() {
  const SHARED_MODAL_ID = 'QuickView-Shared';

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(`[aria-controls="${SHARED_MODAL_ID}"]`);
    if (!trigger) return;

    const modal = document.getElementById(SHARED_MODAL_ID);
    if (!modal) return;

    if (modal.contains(trigger)) return;

    event.preventDefault();

    if (trigger.dataset.productUrl) {
      modal.dataset.productUrl = trigger.dataset.productUrl;
    }
    if (trigger.dataset.productId) {
      modal.dataset.productId = trigger.dataset.productId;
    } else {
      modal.removeAttribute('data-product-id');
    }

    if (typeof modal.show === 'function') {
      modal.show(trigger);
    }
  });
})();
